import { render, staticRenderFns } from "./iconDialog.vue?vue&type=template&id=bb6c7582&scoped=true&"
import script from "./iconDialog.vue?vue&type=script&lang=js&"
export * from "./iconDialog.vue?vue&type=script&lang=js&"
import style0 from "./iconDialog.vue?vue&type=style&index=0&id=bb6c7582&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6c7582",
  null
  
)

export default component.exports